import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { tokens } from '@companycam/slab-tokens';

import CloseButton from './buttons/CloseButton';

const Container = styled.div`
  pointer-events: initial;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  margin: 16px;
  padding: 0 16px 16px 16px;
  border-radius: 4px;
  width: 150px;
  max-height: 70vh;
  overflow-y: auto;
  overflow-x: visible;
  background-color: white;
  border-radius: 4px;
  box-shadow: 0 1px 6px rgba(58, 75, 86, 0.2);
`;

const Header = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin: 0 0 12px 0;
  padding: 0 0 4px 0;
  border-bottom: 1px solid ${tokens.color_border_default_le};
  background-color: white;
  position: sticky;
  top: 0;
  z-index: 1000;
`;

const Title = styled.p`
  color: ${tokens.color_label_dark_gray};
  font-weight: 700;
  font-size: 16px;
  line-height: 1.25;
  font-family: system-ui, -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto,
    'Helvetica Neue', Arial, sans-serif, Roboto, Helvetica Neue, Arial,
    sans-serif;
`;

const SidePanel = ({ children, title, showCloseButton, onClose }) => (
  <Container>
    <Header>
      <Title>{title}</Title>
      {!!showCloseButton && <CloseButton onClick={onClose} />}
    </Header>
    {children}
  </Container>
);

SidePanel.propTypes = {
  children: PropTypes.node,
  title: PropTypes.string,
  showCloseButton: PropTypes.bool,
  onClose: PropTypes.func,
};

SidePanel.defaultProps = {
  children: null,
  title: '',
  showCloseButton: false,
  onClose: () => {},
};

export default SidePanel;
